import styled from 'styled-components';
import SocialMediaLink from './Footer/SocialMediaLink/SocialMediaLink';

export const Wrapper = styled.div`
  padding: 7rem 0 17rem;
  display: flex;
  color: ${({ theme }) => theme.colors.primary.main};
  justify-content: space-between;
  width: 600px;
  margin: 0 auto;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    flex-direction: column;
    width: 100%;
    padding: 4rem 0;
    margin: 6rem 0;
    background-color: ${({ theme }) => theme.colors.functional.white};
    border-radius: ${({ theme }) => theme.borderRadius.main};
    h4 {
      text-align: center;
      padding-bottom: 2rem;
    }
  }
`;

export const SocialMediaContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    flex-direction: column;
    width: 100%;
  }
`;

export const StyledSocialMediaLink = styled(SocialMediaLink)`
  margin-bottom: 0px;
  margin-left: 4rem;
  color: ${({ theme }) => theme.colors.primary.main};
  &:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }
  svg {
    fill: ${({ theme }) => theme.colors.primary.main};
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin: 1rem 0;
  }
`;
